import { RBChannel } from 'store/railsBuilder/reducer.types';
import { Entitlement } from 'store/user/reducer.types';
import { isCapabilityValid } from 'store/utils';

export default function isSubscribedToChannel(
    channelSource: RBChannel,
    entitlements: Entitlement[],
) {
    return !!channelSource.technical.productRefs?.some(
        (channelProductId: string) => {
            const maybeEntitlement = entitlements.find(
                ({ productId }) => channelProductId === productId,
            );

            return isCapabilityValid(maybeEntitlement);
        },
    );
}
